//#region Libraries
import styled from "styled-components";
//#endregion

export const StyledFooter = styled.footer`
    display: flex;
    justify-content: ${({ justify }) => justify};
    gap: 10px;
`;